import { Text } from '@zillow/constellation-10';

const WizardTipContent = (): JSX.Element => {
  return (
    <div data-testid="WizardTipContent">
      <Text css={{ marginBottom: '400' }} asChild>
        <p>Fifty-nine percent of renters have at least one pet.* Allowing pets may attract more applicants.</p>
      </Text>
      <Text textStyle="body-xs" color="text.subtle" asChild>
        <p>*Source: Zillow Consumer Housing Trends Report 2023</p>
      </Text>
    </div>
  );
};

export default WizardTipContent;
